<template>
    <div class="c-appointment-staff">
        <SphereNavigation color="blue" selected="appointment-menu" />

        <div class="inner-content" >
            <template v-if="step == 'STEP_SALES'">
                <div class="step-content">
                    <h1>{{$t('sales_select.title')}}</h1>

                    <div class="step-content-inner">
                        <InputSelect v-model:value="sale"
                            v-if="!loading"
                            :options="sales"
                            :editable="false" class="sales-select"
                        />
                    </div>
                </div>

                <ClientNavButtons
                    prevStep="STEP_MENU"
                    nextStep="STEP_SIZE"
                    @prevStep="prevStep"
                    @showStep="showStep"
                />
            </template>

            <template v-if="step == 'STEP_SIZE'">
                <div class="step-content">
                    <h1>{{$t('appointment_edit.size_staff')}}</h1>

                    <div class="step-content-inner">
                        <ClientSizeInput v-model:size="client.additional_info.size" />
                    </div>
                </div>

                <ClientNavButtons
                    prevStep="STEP_SALES"
                    nextStep="STEP_BED_SIDE"
                    @prevStep="prevStep"
                    @showStep="showStep"
                />
            </template>

            <template v-if="step == 'STEP_BED_SIDE'">
                <div class="step-content">
                    <div class="step-content-inner">
                        <ClientSingleSelect
                            property="bedside"
                            :options="['left','right']"
                            v-model:client="client"
                            @onChange="changeBedSide"
                        />
                    </div>
                </div>

                <ClientNavButtons
                    prevStep="STEP_SIZE"
                    nextStep="STEP_CREATE_APPOINTMENT"
                    @prevStep="prevStep"
                    @showStep="showStep"
                />
            </template>
        </div>

    </div>
</template>

<script>
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import InputSelect from "@/components/InputSelect.vue";
import ClientNavButtons from "@/components/appointments/ClientNavButtons.vue";
import ClientSingleSelect from "@/components/appointments/ClientSingleSelect.vue";
import ClientSizeInput from "@/components/appointments/ClientSizeInput.vue";
import {apiStore} from "@/stores/api";
import LoginMixin from "@/mixins/LoginMixin";
import localforage from "localforage";

export default {
    name : "AppointmentStaff",
    mixins : [LoginMixin],

    components : {
        ClientSingleSelect,
        ClientSizeInput,
        ClientNavButtons,
        SphereNavigation,
        InputSelect
    },

    data() {
        return {
            step: "STEP_SALES",
            loading: true,
            client: {
                additional_info: {
                    is_staff: true,
                    size: 175,
                    bedside: "left"
                }
            },
            sales: [],
            sale: null,
            salesInfo: {},
            savedSizes: {}
        };
    },

    async created() {
        let sales = await apiStore().getSalesForShop();
        for (const sale of sales) {
            const fullName = `${sale.firstname} ${sale.lastname}`;
            this.salesInfo[fullName] = {
                id: sale.id,
                firstname: sale.firstname,
                lastname: sale.lastname,
                email: sale.email
            };
        }
        sales = sales.map(sale => {
            return `${sale.firstname} ${sale.lastname}`;
        });
        this.sales = sales;

        this.sale = this.loggedInSales.firstname + " " + this.loggedInSales.lastname;
        this.loading = false;

        this.savedSizes = await localforage.getItem("staff_sizes");
        if (!this.savedSizes) {
            this.savedSizes = {};
        }

        if (this.savedSizes && this.savedSizes[this.sale]) {
            this.client.additional_info.size = this.savedSizes[this.sale];
        }
    },

    methods: {
        prevStep(step) {
            if (step === "STEP_MENU") {
                this.$router.push({name : "appointment-menu"});
            } else {
                this.showStep(step);
            }
        },

        async showStep(step) {
            this.step = step;

            if (step === "STEP_BED_SIDE") {
                this.savedSizes[this.sale] = this.client.additional_info.size;
                localforage.setItem("staff_sizes", JSON.parse(JSON.stringify(this.savedSizes)));
            } else if (step === "STEP_CREATE_APPOINTMENT") {
                this.client.firstname = this.salesInfo[this.sale].firstname;
                this.client.lastname = this.salesInfo[this.sale].lastname;
                this.client.email = this.loggedInUser.email;
                this.client.additional_info.gdpr = true;
                const appointment = await apiStore().createAppointmentWithClient(this.client, this.$i18n.locale, true);
                this.$router.push({name : "appointment-schedule", params:{id : appointment.id}});
            }
        },

        changeBedSide(bedSide) {
            this.bedSide = bedSide;
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-appointment-staff {
        height: 100%;

        .inner-content {
            height: 95%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            .step-content {
                width: 100%;
                height: 100%;

                .step-content-inner {
                    margin-left: 11%
                }
            }
        }

        &:deep(.client-nav-buttons) {
            margin: 0;
            justify-content: center;
        }

        &:deep(.c-client-size-input) {
            width: 95%;
        }
    }

    .sales-select {
        margin-top : 2rem;
        width : 20rem;

        &:deep(.option) {
            text-align: left;
            padding-left: 1.5rem;
        }

        &:deep(.value) {
            text-align: left;
        }
    }
</style>